import { render } from "./SUPPORT_CASE_CREATED.vue?vue&type=template&id=45db1b85&ts=true"
import script from "./SUPPORT_CASE_CREATED.vue?vue&type=script&lang=ts"
export * from "./SUPPORT_CASE_CREATED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__